// extracted by mini-css-extract-plugin
module.exports = {"emptyContent":"EmptyContent_emptyContent__3FG53","emptyNotification":"EmptyContent_emptyNotification__JiQIT"};